
import { environment } from '../../../../../environments/environment';

export const site = {

    website: environment.website,
    displayWebsite: environment.displayWebsite,
    email: environment.email,
    apiHost: environment.apiHost,
    profileUrl: environment.profileUrl,
    logoUrl: environment.logoUrl,
    picStories: environment.picStories,
    phoneNumber: environment.phoneNumber

}

export const spekwo = {
    phoneNumber: site.phoneNumber,
    website: site.website,
    displayWebsite: site.displayWebsite,
    profileApiUrl: site.profileUrl,
    logoApiUrl: site.logoUrl,
    picStories: site.picStories,

    prouct1: 'HIQFULL',
    prouct2: 'INSPECTIONCALL',
    prouct3: 'GCCONSULTING',
    prouct4: 'CGPYWCK',
    prouct5: 'RJCZPSJ',

    'logoUrl': 'assets/images/logos/spekwo.png',
    'defaultUrl': 'assets/images/avatars/profile.jpg',
    'defaultImg': 'assets/images/avatars/default.jpg',
    'defaultLogo': 'assets/images/avatars/blank.png',
    'defaultStory': 'assets/images/avatars/blank.png',
    'productImg': 'assets/images/ecommerce/product-image-placeholder.png',

    'All Users': 'All Users',

    'Owner': 'Owner',
    'Solution Estimate': 'Solution Estimate',
    'speK ExeC': 'speK ExeC',
    'Senior Estimator': 'Senior Estimator',
    'Estimator': 'Estimator',
    'Spekwo Manager': 'Spekwo Manager',
    'Pro': 'Pro',

    'HIQFULL': 'Full Spekwo',
    'GCCONSULTING': 'Walk and Talk',
    'INSPECTIONCALL': 'SpeK - Call ',
    'RJCZPSJ': 'The Pre-List speK-Sheet',
    'CGPYWCK': 'Specific Item speKwo',
};

export const checkoutFields = {
    failed: 'Failed',
    completed: 'completed',
    noRecords: 'No records found',
    buyerProperty: 'billing_myfield2',
}

export const host = site.apiHost;

export const apiUrl = {

    listOrders: host + 'orders.php',
    updateOrder: host + 'update_order.php',
    ordeAttachment: host + 'attachment.php',
    payment: host + 'payment.php',
    createCustomerToPayment: host + 'createCustomerToPayment.php',
    profileUpload: host + 'profile.php',
    logoUpload: host + 'uploadLogo.php',
    uploadDocuments: host + 'uploadProfileDocuments.php',
    uploadPhotoCollege: host + 'uploadPhotoCollege.php',

    sentContactMail: host + 'sendContactMail.php',
    sentDeclineNotifyMail: host + 'sendDeclineEmailToAdmin.php',

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/spekwo.ts